import {NotificationDeterminant} from "./notification-determinant";

export class Notification {
  public id: string;
  public content = "";
  public determinants: NotificationDeterminant[];
  public value: string;
  public jsonDeterminants: string;
  public tag: string;
  public notificationType: NotificationType;
}

export enum NotificationType {
  GUIDE = "GUIDE" as any,
  FIELD = "FIELD" as any,
}
